import { FiShoppingCart } from 'react-icons/fi';
import { useDarkMode } from '../../context/DarkModeContext';

export default function CartPill({
  itemCount,
  total,
  onClick,
  disabled = false,
  showTotal = true,
  label = 'Ver Carrito',
}) {
  const { COL } = useDarkMode();
  const bg = COL.bg || '#F5F7FA';
  const gradient = `linear-gradient(transparent 0%, ${bg}ee 25%, ${bg} 100%)`;
  const btnBg =
    disabled || itemCount === 0
      ? COL.faint || '#D1D5DB'
      : `linear-gradient(135deg, ${COL.pri2}, ${COL.pri})`;
  const badgeBg = COL.red || '#ea4335';

  return (
    <div
      style={{
        position: 'sticky',
        bottom: '0',
        left: '0',
        right: '0',
        padding: '8px 12px 12px',
        background: gradient,
        zIndex: 50,
      }}
    >
      <button
        onClick={onClick}
        disabled={disabled || itemCount === 0}
        style={{
          width: '100%',
          padding: '14px 20px',
          borderRadius: '16px',
          border: 'none',
          background: btnBg,
          color: '#FFFFFF',
          fontSize: '16px',
          fontWeight: 800,
          cursor: disabled || itemCount === 0 ? 'default' : 'pointer',
          fontFamily: 'inherit',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: disabled || itemCount === 0 ? 'none' : `0 4px 20px ${COL.pri2}58`,
          transition: 'transform 0.15s, box-shadow 0.15s',
          userSelect: 'none',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ position: 'relative' }}>
            <FiShoppingCart size={20} />
            {itemCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-10px',
                  background: badgeBg,
                  color: '#fff',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  fontSize: '10px',
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {itemCount > 99 ? '99+' : itemCount}
              </span>
            )}
          </div>
          <span style={{ fontSize: '14px', opacity: 0.9 }}>{label}</span>
        </div>
        {showTotal && itemCount > 0 && <span>{total}</span>}
      </button>
    </div>
  );
}
